<template>
  <bk-page class="bk-emailVerify" pageType="navPage" :navBarInfo="navBarInfo" @clsoe="close">

    <bk-view :loading="bkLoad" class="view-content">
      <bk-view class="view-authentication">
        <bk-title lang-code="verify_text_authentication"></bk-title>
      </bk-view>

      <bk-view class="view-authenticationInfo">
        <bk-view>{{ showText }}</bk-view>
        <bk-view class="" @click="retry">
          <bk-lang code="verify_text_resend"></bk-lang>
          <span v-if="time != 0">({{ time }})</span>
        </bk-view>
      </bk-view>

      <bk-view class="view-verificationCode phone_code_single">
        <bk-view class="view-showInput">
          <bk-input diffDeviceFlag v-model:value="code" autofocus :maxlength="6" size="full"
                    @change="valueChange"></bk-input>
        </bk-view>

        <bk-view class="phone_code_single_codeinput">
          <bk-view v-for="(item,index) in 6" :key="index">
            {{ code[index] }}
          </bk-view>
        </bk-view>
      </bk-view>


      <bk-view class="view-keyboard ">
        <bk-keyboard type="number" :maxLength="6" @change="keyboardChange" @enter="verifyBtnClick"></bk-keyboard>
      </bk-view>

    </bk-view>

  </bk-page>
</template>

<script>
	import { userReq } from '@/reqService/index';

	export default {
		name: 'bk-emailVerify',
		props: {
			email: String,
		},
		data () {
			return {
				navBarInfo: {
					backFlag: true,
				},
				bkLoad: false,
				timer: null,
				time: 60,
				code: '',
			};
		},
		computed: {
			showText (){
				return this.email;
			}
		},
		watch: {
			time (val) {
				if (val === 0) {
					clearInterval(this.timer);
				}
			},
		},
		mounted () {
			this.getTimer();
		},
		methods: {
			keyboardChange (e) {
				this.code = e;
			},
			close () {
				this.$emit('close');
			},
			async verifyBtnClick () {
				
				if(this.code?.length < 6){
					this.$bk_message.error({langCode:'bkEmailVerify_msg_enterCode'});
					return false;
				}

				this.$emit('confirm', this.code);
			},
			retry () {
				if (this.time == 0) {
					this.time = 60;
					this.getTimer();
				}

			},
			async getTimer () {
				const { custId, compId } = this.$bk_getShopDetailInfo();
				let params = {
					'toEmail': this.email,
					'subject': 'Identity Confirmation',
					'content': 'Your verification code is {verifyCode}, it will expire in 5 minutes. Do not share it with anyone.',
					'pushType': 'VERIFICATION_CODE',
					'source': 'MASE_APP_C',
					custId, compId
				};

				const res = await userReq.requestPostLogin(this, params).catch(() => {
					this.time = 0;
				});
				if (res) {
					this.timer = setInterval(() => {
						if (this.time == 0) {
							clearInterval(this.timer);
							return;
						}
						this.time--;
					}, 1000);
				} else {
					this.time = 0;
				}

			},
			valueChange () {

			},

			codefocusFun (index) {
			},

		},
	};
</script>

<style lang="less" scoped>
@import './bk-emailVerify.less';
</style>